export default (value: any) => JSON.parse(JSON.stringify(value));
